import http from './api'

const route = 'app/baseatendimento/'

export default {
  showBaseAtendimento: (dataInicial, dataFinal, empresaSelect, cidades, vendedores, redes, tokencontrato, areas, segmento) => {
    return http.post(route + 'showBaseAtendimento', {
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      empresas: empresaSelect,
      cidades: cidades,
      vendedores: vendedores,
      redes: redes,
      tokenContrato: tokencontrato,
      areas: areas,
      segmento: segmento,
    })
  },
}
